import React, { useEffect, useRef, useState } from 'react';
import PolicyConsentModal from '../components/policy/policy-consent-modal';
import { getConsentStatus } from '../api/user/consent.api';

/**
 * Cổng "bấm đồng ý điều khoản" tái dùng cho 1 tính năng.
 * Dùng: const gate = useConsentGate('wallet-topup');
 *   - bọc hành động: onClick={() => gate.run(() => doTopup())}
 *   - render modal:  {gate.modal}
 * Nếu chưa đồng ý → hiện điều khoản; đồng ý xong tự chạy tiếp hành động.
 */
export function useConsentGate(policyKey: string) {
  const [accepted, setAccepted] = useState<boolean | null>(null);
  const [open, setOpen] = useState(false);
  const pending = useRef<null | (() => void)>(null);

  useEffect(() => {
    let alive = true;
    getConsentStatus([policyKey])
      .then((list) => alive && setAccepted(!!list.find((x) => x.key === policyKey)?.accepted))
      .catch(() => alive && setAccepted(false));
    return () => {
      alive = false;
    };
  }, [policyKey]);

  const run = (action: () => void) => {
    if (accepted) action();
    else {
      pending.current = action;
      setOpen(true);
    }
  };

  const modal = (
    <PolicyConsentModal
      open={open}
      policyKey={policyKey}
      onClose={() => setOpen(false)}
      onAccepted={() => {
        setAccepted(true);
        setOpen(false);
        const a = pending.current;
        pending.current = null;
        if (a) a();
      }}
    />
  );

  return { run, modal, accepted };
}
